module.exports = __webpack_public_path__ + "static/media/img_faceassessmenton_nose_ratio.11e674a8.jpg";